import React, { useState, useEffect } from 'react'
import { string, func } from 'prop-types'
import SearchBar from './SearchBar'

const SearchBarWithState = ({ query = '', clearQuery = null, ...rest }) => {
  const [q, setQuery] = useState(query)
  useEffect(() => {
    setQuery(query)
  }, [query])
  return (
    <SearchBar
      query={q}
      handleInput={e => setQuery(e.target.value)}
      clearQuery={() => {
        setQuery('')
        if (clearQuery) {
          clearQuery()
        }
      }}
      {...rest}
    />
  )
}

SearchBarWithState.propTypes = {
  query: string,
  clearQuery: func
}

export default React.memo(SearchBarWithState)
